module.exports = __webpack_public_path__ + "img/ic-max.af64f9ff.svg";